export enum SegmentoContrato {
  Saude,
  Odontologico,
  Food,
}
